import { render } from "./SchedulerBoard.vue?vue&type=template&id=52793bbc&scoped=true"
import script from "./SchedulerBoard.vue?vue&type=script&lang=js"
export * from "./SchedulerBoard.vue?vue&type=script&lang=js"

import "./SchedulerBoard.vue?vue&type=style&index=0&id=52793bbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52793bbc"]])

export default __exports__